export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";